
export default class Constants { 
  public static IUCN_SPLASH_DO_NOT_SHOW_AGAIN = 'IUCN_SPLASH_DO_NOT_SHOW_AGAIN';
  public static IUCN_KEEP_SIGNED_IN = 'IUCN_KEEP_SIGNED_IN';  
}
